import { useState, useEffect } from "react";
import listServices from "../services/listServices";

const ListSelector = ({ userKey, p_idList=null, onSelect , disabled = false}) => {
  const [lists, setLists] = useState([]); // Stocke les listes récupérées
  const [selectedList, setSelectedList] = useState(""); // Stocke la valeur sélectionnée  

  useEffect(() => {
    const fetchLists = async () => {
      const extractedLists = await listServices.getAllListByKey(userKey);
      setLists(extractedLists || []); // Assure que "lists" est bien un tableau
    };

    if (userKey) fetchLists();
  }, [userKey]); // Rafraîchir si `userKey` change

  // 🔥 Gère la sélection d’une liste
  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedList(value);
    if (onSelect){
      if(value === 0){
        p_idList = null;
        onSelect(null);
      }
      else 
      { 
        p_idList = value;
        onSelect(value);
      }
    }
  };


return (
  <div>
    <select id="list-selector" value={p_idList || selectedList} onChange={handleChange} disabled={disabled}>
      <option value="">-- Choisir une liste --</option>
      {lists.map((list) => (
        <option key={list.id} value={list.id}>
          {list.name}
        </option>
      ))}
      {/* <option value="new">➕ Ajouter une nouvelle liste</option> */}
    </select>
  </div>
);
};

export default ListSelector;
